'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  color: ', ';\n  font-size: ', ';\n  line-height: 1;\n  vertical-align: baseline;\n  bottom: ', ';\n  position: relative;\n  font-weight: ', ';\n'], ['\n  color: ', ';\n  font-size: ', ';\n  line-height: 1;\n  vertical-align: baseline;\n  bottom: ', ';\n  position: relative;\n  font-weight: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  padding-right: 2px;\n  bottom: ', ';\n  font-weight: ', '\n'], ['\n  padding-right: 2px;\n  bottom: ', ';\n  font-weight: ', '\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  line-height: ', '\n'], ['\n  line-height: ', '\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _pclnDesignSystem = require('pcln-design-system');

var _sizeMap = require('../../../helpers/sizeMap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var propTypes = {
  className: _propTypes2.default.string,
  size: _propTypes2.default.string,
  price: _propTypes2.default.number,
  color: _propTypes2.default.string,
  toFixDecimal: _propTypes2.default.number,
  isStrikePrice: _propTypes2.default.bool,
  currencySymbol: _propTypes2.default.string,
  priceIcon: _propTypes2.default.string,
  currencyAutoId: _propTypes2.default.string,
  strikePriceSrOnlyText: _propTypes2.default.string,
  priceDescription: _propTypes2.default.string,
  bold: _propTypes2.default.bool
};

var defaultProps = {
  currencySymbol: '$',
  isStrikePrice: false,
  size: 'large',
  color: 'gray',
  toFixDecimal: 2,
  priceDescription: '',
  strikePriceSrOnlyText: 'Price marked down from original price of'
};

var Sup = _styledComponents2.default.sup(_templateObject, function (props) {
  return props.theme.colors[props.color];
}, function (props) {
  return props.fontSize + 'px';
}, function (props) {
  return props.isStrikePrice ? _sizeMap.stikePriceBottomMap[props.size] : props.size !== 'large' ? '1.3ex' : '1.2ex';
}, function (props) {
  return props.fontWeight ? props.fontWeight : props.isStrikePrice && !props.bold ? 'normal' : 'bold';
});

var CurrencySup = (0, _styledComponents2.default)(Sup)(_templateObject2, function (props) {
  return props.isStrikePrice ? _sizeMap.stikePriceBottomMap[props.size] : '1.3ex';
}, function (props) {
  return !props.isStrikePrice || props.bold ? 'bold' : 'normal';
});

var StyledWrapper = _styledComponents2.default.span(_templateObject3, function (props) {
  return props.lineHeight + 'px';
});
var GenericPrice = function GenericPrice(_ref) {
  var className = _ref.className,
      size = _ref.size,
      price = _ref.price,
      color = _ref.color,
      toFixDecimal = _ref.toFixDecimal,
      isStrikePrice = _ref.isStrikePrice,
      currencySymbol = _ref.currencySymbol,
      priceIcon = _ref.priceIcon,
      currencyAutoId = _ref.currencyAutoId,
      strikePriceSrOnlyText = _ref.strikePriceSrOnlyText,
      priceDescription = _ref.priceDescription,
      bold = _ref.bold;

  var sizeMap = isStrikePrice ? _sizeMap.strikePriceSizeMap : _sizeMap.priceSizeMap;

  var decimal = (price % 1).toFixed(toFixDecimal);
  var displayPrice = Number(decimal) === 1 ? Math.floor(price + Number(decimal)) : Math.floor(price);

  return _react2.default.createElement(
    StyledWrapper,
    {
      className: className,
      lineHeight: sizeMap[size][2] },
    !isStrikePrice && priceIcon && _react2.default.createElement(_pclnDesignSystem.Icon, {
      size: _sizeMap.priceIconSizeMap[size],
      name: priceIcon,
      color: color
    }),
    _react2.default.createElement(
      _pclnDesignSystem.Text.span,
      {
        'data-unit-id': 'PRICE',
        bold: !isStrikePrice || bold,
        fontWeight: !isStrikePrice || bold ? 'bold' : 'regular',
        color: color,
        fontSize: sizeMap[size][0] },
      isStrikePrice && _react2.default.createElement(
        _pclnDesignSystem.SrOnly,
        null,
        strikePriceSrOnlyText,
        '\xA0'
      ),
      _react2.default.createElement(
        CurrencySup,
        {
          size: size,
          isStrikePrice: isStrikePrice,
          color: color,
          fontSize: sizeMap[size][1],
          bold: bold,
          'data-unit-id': 'CURRENCY'
        },
        _react2.default.createElement('span', {
          dangerouslySetInnerHTML: { __html: currencySymbol },
          'data-autobot-element-id': currencyAutoId
        })
      ),
      displayPrice
    ),
    (decimal > 0 || price === 0) && decimal < 1 && toFixDecimal > 0 && _react2.default.createElement(
      Sup,
      {
        size: size,
        isStrikePrice: isStrikePrice,
        color: color,
        fontSize: sizeMap[size][1],
        bold: bold,
        'data-unit-id': 'DECIMAL' },
      '.',
      decimal.split('.')[1]
    ),
    priceDescription && _react2.default.createElement(
      _pclnDesignSystem.Text.span,
      { color: color },
      _react2.default.createElement(
        Sup,
        { fontSize: sizeMap[size][1], fontWeight: 'normal' },
        priceDescription
      )
    )
  );
};

GenericPrice.propTypes = propTypes;
GenericPrice.defaultProps = defaultProps;

exports.default = GenericPrice;